import React from 'react';
import { Link } from 'react-router-dom'

import NotificationActions from '../../flux/NotificationActions.js';

class Alert extends React.Component {
    constructor (props) {
        super(props)
    }

    next () {
        NotificationActions.nextNotification();
    }

    render () {
        return <div className={'notification notification-' + this.props.notification.type}>
            <div className="clearfix">
                <span className="close" onClick={this.next}><i className="fa fa-times"/></span>
                {this.renderHeader()}
            </div>

            {this.props.notification.messages.map(function (message, index) {
                return <p key={'notification-message-' + index}>{message}</p>;
            })}

            {this.renderFooter()}
        </div>
    }

    renderHeader () {
        var name, icon;
        switch (this.props.notification.type) {
            case 'alert':
                name = 'Alert';
                icon = <i className="fa fa-exclamation-triangle"/>;
                break;

            case 'warning':
                name = 'Warning';
                icon = <i className="far fa-bell"/>;
                break;

            case 'success':
                name = 'Success';
                icon = <i className="fa fa-star"/>;
                break;

            case 'info':
                name = 'Info';
                icon = <i className="fa fa-info"/>;
                break;
        }

        return (
            <header>
                {icon} <h3>{name}</h3>
            </header>
        );
    }

    renderFooter () {
        if (!this.props.notification.eventID) return <span/>;
        return (
            <div>
                <hr/>
                <div className="text-right">
                    Event: <strong><Link to={'/events/?evenID=' + this.props.notification.eventID}>{this.props.notification.eventID}</Link></strong>
                </div>
            </div>
        );
    }
}

export default Alert;
